// eslint-disable-next-line no-undef
const browserLocalStorage = (typeof window !== 'undefined') ? window.localStorage : null;
export default browserLocalStorage;
